module.exports = __webpack_public_path__ + "img/bg-01.2039eccc.jpg";